import { Box, styled } from '@mui/material'

export const FooterBox = styled(Box)(({ theme }) => ({
  background: 'radial-gradient(19.82% 71.24% at 38.62% 1.89%, #05213C 0%, #05081A 100%)',
  padding: '48px 20px',
  [theme.breakpoints.up('md')]: {
    padding: '100px 20px'
  }
}))
